import React, { useState } from 'react';
import { X, CheckCircle } from '@phosphor-icons/react';
import FormField from '../../forms/components/FormField';

/**
 * Vista previa de un formulario para el recorrido guiado del técnico (technicianTour).
 * Reproduce el aspecto de DynamicForm con campos de muestra: no carga ni envía datos.
 * @param {Object} form - { title, submitText, fields } (ver TOUR_DEMO_FORMS)
 */
function TourFormPreview({ form }) {
    const [values, setValues] = useState({});
    const handleChange = (index, value) => setValues((previous) => ({ ...previous, [form.fields[index].id]: value }));
    const firstRequiredId = form.fields.find((field) => field.required)?.id;

    return (
        <div className="fixed inset-0 bg-[var(--app-overlay)] flex items-center justify-center z-[9999] p-4">
            <div data-tour="tech-form" data-tour-scroll className="bg-surface rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
                <div className="flex items-center justify-between p-6 border-b border-line">
                    <h2 className="text-xl font-semibold text-content">{form.title}</h2>
                    <X className="w-6 h-6 text-content-muted" />
                </div>

                <div className="p-6 space-y-6">
                    {form.fields.map((field, index) => (
                        <div
                            key={field.id}
                            data-tour={field.type === 'image' ? 'tech-form-images' : field.id === firstRequiredId ? 'tech-form-required' : undefined}
                        >
                            <FormField
                                field={field}
                                index={index}
                                value={values[field.id]}
                                onChange={handleChange}
                                formId="tour-preview"
                            />
                        </div>
                    ))}

                    <div className="flex justify-end space-x-3 pt-6 border-t border-line">
                        <button type="button" className="px-4 py-2 text-content bg-surface-2 rounded-lg">
                            Cancelar
                        </button>
                        <button type="button" className="px-6 py-2 bg-amber text-on-amber rounded-lg flex items-center">
                            <CheckCircle className="w-4 h-4 mr-2" />
                            {form.submitText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TourFormPreview;
